import {  Component,  
          ChangeDetectorRef,
          ViewChild }                     from '@angular/core';
//*******************************************************
// Router
import { Router, ActivatedRoute }         from '@angular/router';
import {formatNumber}                     from '@angular/common';
//*******************************************************
// Firestore 
import { firestorecontrol }               from "../../appfirestore/app.firestore";

import { Observable, Subscription }       from 'rxjs';

// Functions
import { appfunctions  }                                    from '../../functions/app.functions';
//*******************************************************
// Devexpress Components
import {  DxTreeListComponent,
          DxChartComponent }                from 'devextreme-angular';
//*******************************************************
// Field Definitions
import  { 
          whoseguestinit,
          financedashboard,
          barchartfinance,
          collaboratordetail,
          barchartfinance1,
          barchartfinanceTreeList
        }                                 from '../../appfirestore/app.fields';
//*******************************************************
@Component
  (
    
    {
      selector: 'app-commfinancesnapshot',
      templateUrl: './commfinancesnapshot.component.html',
      styleUrls: ['./commfinancesnapshot.component.scss']
    }
  
  )
//*******************************************************
export class CommfinancesnapshotComponent
  {
     //*******************************************************
     @ViewChild('financetree') TreeList_Finance: DxTreeListComponent;
     @ViewChild('barfinancechart') BarChart: DxChartComponent;
    //*******************************************************
    eventid: string = '';
    formheight: number = 0;

    // Event Organisers
    whoseguest: Array<whoseguestinit> = []; // Empty Array
    selorganiserlist: string[] = [];
    organisername: string;
    organiserid: string;

    subscriptiondashboardfinance: Subscription;
    subscriptiondashboardfinancelist: financedashboard[];

    subscriptioncollaborator: Subscription;
    subscriptioncollaboratorlist: collaboratordetail[];

    // Chart
    barchart: Array<barchartfinance1> = []; // Empty Array
    totalfullBudget: number = 0;
    totalbudget:      number = 0;
    totalbudgettask:  number = 0;
    totalactualtask:  number = 0;
    totalactualalloctask: number = 0;
    totalactualalloctaskbar: number = 0;
    totalsavings:     number = 0
    savingcost: string = "TBC:"

    linebudgettotaltext: string = '';
    linebudgettext: string = '';
    linealloctext: string = '';
    lineactualtext: string = '';

    totalbudgetspend: number = 0;
    totalbudgetspendS: string = '';

    totalactualspend: number = 0;
    totalactualspendS: string = '';

    totalactualallocspend: number = 0;

    // TreeList
    barcharttree: Array<barchartfinanceTreeList> = []; // Empty Array
    barcharttitle: string = 'Please select Total OR Event Organiser'

    setmaxYvalue: number = 0;
    setminYValue: number = 0;
    constantlinewidth: number = 0
    constantline0width: number = 1
    charttooltip: boolean = false;
   
    showprovider: boolean = false;
    positionOf: string;

    contactperson: string = '';
    mobile: string = '';
    phone: string = '';
    notes: string = '';

    visibleYaxis: boolean = false;
    //*******************************************************
    constructor (
                  private routernavigate: Router,
                  private firestoredata: firestorecontrol, 
                  private appfunction: appfunctions,
                  private ref: ChangeDetectorRef,
                  private _Activatedroute:ActivatedRoute
                ) 
        { 
            //-------------------------------------------------------------------------------------------- 
            this.customizeTooltip  = this.customizeTooltip.bind( this );
            //--------------------------------------------------------------------------------------------
        }
    //*******************************************************
    ngOnInit(): void 
      {
          // EventId
          this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
          // Form Height
          this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
          //--------------------------------------------------------------------------------------------
          // Event Organiser Initials
          this.firestoredata.buildwhoseguestdetails( this.eventid );
          this.whoseguest = this.firestoredata.geteventparticipantdetails();

          // Creating a Total 
          this.whoseguest.push
                                  (
                                    {
                                      id: 'total',
                                      initial: 'Total',
                                      fullname: 'Total'
                                    }
                                  )
          //console.log( this.whoseguest )
          //---------------------------------------------------------------------------------------------  
      }
    //*******************************************************
    ngAfterViewInit() 
      {
        this.ref.detectChanges();
      }
  //*******************************************************
    ngOnDestroy() 
      {
     
      
        if (typeof this.subscriptioncollaborator != 'undefined'  )
          {
            this.subscriptioncollaborator.unsubscribe()
          }
      
      }
    //*******************************************************
    buildstats( event: any)
      {
        //console.log( event )
       
        this.organiserid              = event.itemData.id
        this.organisername            = event.itemData.fullname;
        this.barcharttree             = [];
       //console.log(  this.organiserid )

        this.buildBarChart( event.itemData.id, event.itemData.fullname  )
      }
    //*******************************************************
    // Build Bar Chart
    buildBarChart( selorganiser: string, organisername: string )
      {
        //---------------------------------------------------------------------------------------------
        // Determine Event Organiser to Search for
        this.selorganiserlist = []
        var coststatus: string = 'TBC';

        if (  selorganiser == 'total') // Tota;l + All Listed Event Organisers
          {

            this.barcharttitle = 'Financial Statistics-Allocated Spend for Total Event';
         
            // Add Event Organiser 
            for (let i = 0; i < this.whoseguest.length; i++) 
              {
                  if ( this.whoseguest[i].id != 'total' ) 
                    {
                      this.selorganiserlist.push( this.whoseguest[i].id) 
                    }
              }
          }
        else
          {
            this.barcharttitle = 'Financial Statistics-Allocated Spend for ' + this.organisername;
           

            this.selorganiserlist.push( selorganiser )
          }

         // console.log(  this.selorganiserlist )

        //---------------------------------------------------------------------------------------------
        // Build Graph = Bar Chart 
        // Collate Event Organiser Spending - dashboard -> Finance
        // Selection for Dropdown ComboBox
        this.firestoredata.loadeventdashboardFinance( this.eventid, selorganiser);

        this.subscriptiondashboardfinance = this.firestoredata.geteventdashboardfinance().subscribe
          ( items => 
            { 
              this.subscriptiondashboardfinancelist = items;

              this.totalfullBudget = this.subscriptiondashboardfinancelist[0].totalbudget;
        
              // Total BudgetCost which has been allocated
             // this.totalbudget      = this.subscriptiondashboardfinancelist[0].totalbudgetcost;   
              this.totalbudget      = this.subscriptiondashboardfinancelist[0].totalABSbudgetcost  
            //  this.totalbudgettask  = this.subscriptiondashboardfinancelist[0].totalbudgetcosttask;
             // this.totalbudgettask  = 0 
              
              // Total ActualCost which has been allocated
              //this.totalactualtask  = this.subscriptiondashboardfinancelist[0].totalactualcost;

              this.totalactualalloctaskbar  = this.subscriptiondashboardfinancelist[0].totalactualcost; 
              this.totalactualtask          = this.subscriptiondashboardfinancelist[0].totalABSactualcost;
              
              this.totalsavings     = 0;

              if (  this.totalactualtask > 0  )
              {
                this.totalsavings  = this.totalbudget - this.totalactualtask

                if ( this.totalsavings > 0 )
                  {
                    this.savingcost = 'Savings:'
                    coststatus      = 'Positive';
                  }
                else
                  {
                    this.savingcost = 'Cost:'
                    coststatus = 'Negative';
                  }
              }
              
             // if (  this.totalbudgettask > 0 && this.totalactualtask > 0  )
             //   {
              //    this.totalsavings  = this.totalbudget - this.totalactualtask

              //    if ( this.totalsavings > 0 )
              //      {
               //       coststatus = 'Positive';
              //      }
              //    else
              //      { coststatus = 'Negative';

               //     }

             //  }

               
                 
             // this.constantlinetext = 'Total Budget Estimate: ' + this.totalbudget.toString();

              this.linebudgettotaltext = 'Total Budget: ' + this.totalfullBudget;

              this.linebudgettext = 'Budget: ' + this.totalbudget;
              this.lineactualtext = 'Actual: ' + this.totalactualtask;

              if (  this.organiserid == 'total')
                this.linealloctext  = 'Team: '   + this.totalactualalloctaskbar;
              else
                this.linealloctext  = 'My Share: '     + this.totalactualalloctaskbar;

              // Constant Line Width
              this.constantlinewidth = 3;

              // Determine Maximum Number
             // const maxnumbers: number[] = [this.totalbudget, this.totalbudgettask, this.totalactualtask, this.totalsavings];
              const maxnumbers: number[] = [this.totalfullBudget, this.totalbudget, this.totalactualtask, this.totalsavings];
              //const maxnumbers: number[] = [this.totalbudgetspend, this.totalactualspend, this.totalsavings];
              const maxNumber: number = maxnumbers.reduce((a, b) => Math.max(a, b));
              this.setmaxYvalue = maxNumber+500;
              
              // Determine Min Number
             // const minnumbers: number[] = [this.totalbudget, this.totalbudgettask, this.totalactualtask, this.totalsavings];
              const minnumbers: number[] = [this.totalfullBudget, this.totalbudget, this.totalactualtask, this.totalsavings];
              //const minnumbers: number[] = [this.totalbudgetspend, this.totalactualspend, this.totalsavings];
              const minNumber: number = minnumbers.reduce((a, b) => Math.min(a, b));
          
              this.setminYValue = 0;
              if ( minNumber < 0 )
                {
                  this.setminYValue = minNumber + -100;
                }
              //---------------------------------------------------------------------------------------------
              // Create Bar Chart
              this.barchart = []; // Empty Array

              this.barchart.push(
                                  {
                                    costtype: 'Budget Total',
                                    amount: this.totalfullBudget
                                  },
                                  {
                                    costtype: 'Budget',
                                    amount: this.totalbudget 
                                  },
                               //   {
                               //     costtype: 'Budget',
                               //    amount: this.totalbudgettask 
                                //  },

                                  {
                                    costtype: 'Actual',
                                    amount: this.totalactualtask 
                                  },
                                  // Cost Savings OR Expense
                                  {
                                    costtype: coststatus,
                                    amount: this.totalsavings 
                                  }
                                )

              //    this.barchart.push(   
              //                        {
              //                         eventparticipant: '',
              //                         totalbudget:      this.totalbudget,
              //                         totalbudgettask:  this.totalbudgettask,
              //                         totalactualtask:  this.totalactualtask,
              //                         setMaxYValue:     this.setbudgetvalue
              //                       }
              //                     );

              if ( this.barchart.length > 0 ) 
                {
                  this.visibleYaxis = true;

                  this.BarChart.instance.refresh();
                }

            }
          )

      }
   //******************************************************* 
   orderLegendItems(items: any) 
      {
        return items.sort((a, b) => {
                                      let itemA = a.id
                                      let itemB = b.id
                                      if(itemA > itemB) return 1;
                                      if(itemA < itemB) return -1;
                                      return 0;
                                    }
                         )
      
      };  
   //*******************************************************
   customizeText(arg) 
    {
      return `Day ${arg.valueText}`;
    }
  //*******************************************************
  customizeSeries( valueFromNameField: string) 
    {
      
      switch (  valueFromNameField )
        {

          case 'Budget Total':    return { type: 'bar', label: { visible: false, backgroundColor:"#c18e92"}, color: '#91A3B0' };

          case 'Budget':          return { type: 'bar', label: { visible: false, backgroundColor:"#c18e92"}, color: '#91a3b0' };

          case 'Actual':          return { type: 'bar', label: { visible: false }, color: '#87ceeb' };

          case 'Positive':        return { type: 'bar', label: { visible: true }, color: '#009933' };

          case 'Negative':        return { type: 'bar', label: { visible: true }, color: '#ff3f7a' };

          default:  return {};

        }      

    }
  //*******************************************************
  onPointClick(event: any) 
    {
      //console.log(event)
      //---------------------------------------------------------------------------------------------
      var parentid: number = 0;             // Collaborator Id
      var actualcost: number = 0            // Actual Cost deem confirm 
      var actualcostallocated: number = 0;  // Actual Cost Allocated deem confirm 
      var actualcostperc: number = 0;
      var budactvariance: number;
      //---------------------------------------------------------------------------------------------
      // Only Applicable to Bar-Actual
      if ( event.target.argument == 'Actual')
        {
          this.BarChart.instance.hideTooltip();

          // All Event Participants -> this.selorganiserlist
          // Firestore - Collaborators
          this.firestoredata.loadeventcollaborator( this.eventid, 20, '', this.selorganiserlist );
        
          this.subscriptioncollaborator = this.firestoredata.geteventcollaborator().subscribe
            ( items => 
              {   
                var myNumber: number              = 0;
                this.barcharttree                 = [];
                this.subscriptioncollaboratorlist = items;
                
               // console.log( this.subscriptioncollaboratorlist.length )
              //  console.log( this.subscriptioncollaboratorlist )

                if ( this.subscriptioncollaboratorlist.length > 0 )
                  {
                    
                    this.TreeList_Finance_Node_Expand_Collapse(0)

                    this.totalbudgetspend       = 0;
                    this.totalactualspend       = 0;
                    this.totalactualallocspend  = 0;

                    for (let i = 0; i < this.subscriptioncollaboratorlist.length; i++) 
                      {
                        // console.log( this.subscriptioncollaboratorlist[i] );

                        // Determine Parent Id
                        //  parentid = this.subscriptioncollaboratorlist[i].id;
                        //    budactvariance = (+this.subscriptioncollaboratorlist[i].budget) - (+this.subscriptioncollaboratorlist[i].amount)
                        //---------------------------------------------------------------------------------------------
                        // Calculate Actual Cost Allocated for each Collaborator
                        let eventorgansiercnt1  = this.subscriptioncollaboratorlist[i].sharecost.length;
                        actualcost              = 0;
                        actualcostallocated     = 0;
                        actualcostperc          = 0;

                        this.totalbudgetspend   = this.totalbudgetspend + this.subscriptioncollaboratorlist[i].budget;
                        this.totalbudgetspendS  =  formatNumber(this.totalbudgetspend, 'en-US', '1.2-2' ) ;


                        this.totalactualspend   = this.totalactualspend + this.subscriptioncollaboratorlist[i].amount;
                        this.totalactualspendS  =  formatNumber(this.totalactualspend, 'en-US', '1.2-2' ) ;

                        if ( eventorgansiercnt1 > 0 )   
                           {
                             // Calculating Collaborator Profile -> Total
                             for (let j = 0; j < eventorgansiercnt1; j++) 
                              {
                                

                                  let eventorgansierlist = this.subscriptioncollaboratorlist[i].sharecost[j];

                                  let splitsharecost: Array<string> = [];
                                  splitsharecost = eventorgansierlist.split("#");

                                  // [1]=%  [2]=$
                                  if ( +splitsharecost[1] > 0 && +splitsharecost[2] > 0 )
                                    {
                                      actualcost          = actualcost  + +splitsharecost[2];
                                      actualcostallocated = actualcostallocated + ( +splitsharecost[2] * ( +splitsharecost[1] / 100 ) )
                                      actualcostperc      = actualcostperc + +splitsharecost[1]
                                    }

                               }

                           }
                        //---------------------------------------------------------------------------------------------  
                        // Task Id // Provider Id
                        myNumber = myNumber + 1
                        parentid = myNumber

                        this.totalactualalloctask = actualcostallocated;
                       // console.log(  this.totalactualalloctask )

                        this.barcharttree.push  (
                                                  {
                                                   // spendid: +parentid,
                                                   // Collaborator
                                                   spendid: myNumber,

                                                    // Provider Details
                                                    providername:  this.subscriptioncollaboratorlist[i].providername,
                                                    contactperson: this.subscriptioncollaboratorlist[i].contactperson,
                                                    mobile: this.subscriptioncollaboratorlist[i].mobile,
                                                    phone: this.subscriptioncollaboratorlist[i].phone,

                                                    eventorganisername: '',
                                                    budgetamount: this.subscriptioncollaboratorlist[i].budget,
                                                    actualamount: this.subscriptioncollaboratorlist[i].amount,
                                                    actualallocated: actualcostallocated,

                                                    percshare: actualcostperc,

                                                    notes: this.subscriptioncollaboratorlist[i].notes,
                                                 
                                                    spendparentid: 0
                                                  }
                                                );
                      //---------------------------------------------------------------------------------------------
                      // Event Organiser - ShareCost Array
                      let eventorgansiercnt = this.subscriptioncollaboratorlist[i].sharecost.length;

                      if ( eventorgansiercnt > 0 )   
                        {

                          for (let j = 0; j < eventorgansiercnt; j++) 
                            {
                            
                              let eventorgansierlist = this.subscriptioncollaboratorlist[i].sharecost[j];

                              let splitsharecost: Array<string> = [];
                              splitsharecost = eventorgansierlist.split("#");

                              // Total
                              if ( this.organisername == 'Total')
                                {

                                  if ( +splitsharecost[1] > 0 && +splitsharecost[2] > 0 )
                                    {
                                      // Only list EventOrganisers that has
                                      // a: Actual Cost
                                      // b. % Share

                                  //    console.log( splitsharecost[0] + '-' + splitsharecost[1] + '-' + splitsharecost[2])

                                     const result = this.whoseguest.find(({ id }) => id === splitsharecost[0]);

                                      budactvariance = (+splitsharecost[3] * ( +splitsharecost[1] / 100 )) - (+splitsharecost[2] * ( +splitsharecost[1] / 100 ))

                                      myNumber = myNumber + 1
                                      this.barcharttree.push  (
                                                                {
                                                                 // spendid:  +splitsharecost[0],
                                                                 spendid: myNumber,

                                                                  providername: '',
                                                                  contactperson: '',
                                                                  mobile: '',
                                                                  phone: '',

                                                                  eventorganisername:  result.fullname,

                                                                  budgetamount: 0,

                                                                  actualamount: 0,
                                                                  actualallocated: +splitsharecost[2] * ( +splitsharecost[1] / 100 ),

                                                                  percshare: +splitsharecost[1],

                                                                  notes: '',

                                                                  spendparentid: parentid
                                                                }
                                                              );

                                    }

                                }
                              else
                                {

                                  // Event Organiser specific
                                  if ( this.organiserid == splitsharecost[0].trim() ) 
                                    {
                                      this.totalactualallocspend = this.totalactualallocspend + ( +splitsharecost[2] * ( +splitsharecost[1] / 100 ) )
                                      budactvariance = (+splitsharecost[3] * ( +splitsharecost[1] / 100 )) - (+splitsharecost[2] * ( +splitsharecost[1] / 100 ))

                                      
                                      myNumber = myNumber + 1;

                                      this.barcharttree.push  (
                                                                  {
                                                                    spendid:  myNumber,

                                                                    providername: '',
                                                                    contactperson: '',
                                                                    mobile: '',
                                                                    phone: '',

                                                                    eventorganisername:  this.organisername,

                                                                    budgetamount:       +splitsharecost[3] * ( +splitsharecost[1] / 100 ),
                                                                    actualamount:       0,
                                                                    actualallocated:    +splitsharecost[2] * ( +splitsharecost[1] / 100 ),

                                                                    percshare: +splitsharecost[1],

                                                                    notes: '',
                                                                 
                                                                    spendparentid: parentid
                                                                  }
                                                              );

                                    }
                                  }
                            }

                        }                           

                      }

                    this.TreeList_Finance_Node_Expand_Collapse(1)

                  }

              }
            )

        }

    }

  //*******************************************************
  TreeList_Finance_Node_Expand_Collapse( openHide: number)
    {
      if ( this.barcharttree.length > 0 )
        {

          for (let i = 0; i < this.barcharttree.length; i++)   
            {
                if (  +this.barcharttree[i].spendparentid == 0 )
                  {
                    switch ( openHide )
                      {
                        case 0:  // Hide
                          {
                            this.TreeList_Finance.instance.collapseRow( this.barcharttree[i].spendid )

                            break;
                          }

                        case 1:  // Open
                          {
                            this.TreeList_Finance.instance.expandRow( this.barcharttree[i].spendid)
                            
                            break;
                          }
                      }
                  }
            }
        } 
    }
  //*******************************************************
  treerowclick( event: any )
    {

      this.contactperson  = '';
      this.mobile         = '';
      this.phone          = '';
      this.notes          = '';
     
 
       // console.log(event )

      if ( this.barcharttree.length > 0 )
        {
          //console.log( event.data )

          if ( event.data.spendparentid == 0 )
            {
          
              this.showprovider = true;
              this.positionOf           =  `#taskid${event.data.spendid}`;

              this.contactperson  = event.data.contactperson;
              this.mobile         = event.data.mobile;
              this.phone          = event.data.phone;
              this.notes          = event.data.notes;

            }
          else
            {
              //console.log( 'Costid ')
              this.showprovider = false;
            }

        }

    }
    //*******************************************************
    onCellPrepared(event: any) 
      {

        if  (event.rowType == "header" ) 
          {

            event.cellElement.css('font-size', '14px');

          }

        if  (event.rowType == "data" ) 
          {
            //---------------------------------------------------------------------------------------------
            event.cellElement.css('font-size', '12px');
            //---------------------------------------------------------------------------------------------
            if  ( event.column.dataField == "percshare" ) 
              {
                // Collaborator 
                if ( +event.data.spendparentid == 0 )
                {
                  if ( +event.data.percshare == 100 )
                    {
                      event.cellElement.css('background-color', '#000099');
                    }
                  else
                    {
                      //  event.cellElement.css('color', 'red'); // Font
                      //  event.cellElement.css('background-color', 'red');
                      event.cellElement.css('background-color', 'red');
                    }
                }
              }
            //---------------------------------------------------------------------------------------------
            if( event.column.dataField == "actualallocated" ) 
              {
                if ( +event.data.spendparentid == 0 )
                  {
                    if ( +event.data.percshare == 100 )
                      {
                        event.cellElement.css('background-color', '#000099');
                      }
                    else
                      {
                        //  event.cellElement.css('background-color', 'red');
                        event.cellElement.css('background-color', 'red');
                      }
                  }
              }
            //---------------------------------------------------------------------------------------------
            if( event.column.dataField == "actualamount" ) 
              {
                if ( +event.data.spendparentid !== 0 )
                  {
                    event.cellElement.css('color', '#465672');
                  }
              }
            //---------------------------------------------------------------------------------------------
          }
        //---------------------------------------------------------------------------------------------
      }
  //*******************************************************
  onPointHoverChanged( event: any )
    {
      // console.log( event )
      //console.log( event.target.argument )
      if (  event.target.argument == 'Actual' )
        { 
          if ( this.barcharttree.length > 0 )
            {
              event.target.showTooltip();
            }
        }
      else
        {
          this.BarChart.instance.hideTooltip();

        }

    }

  customizeTooltip(event: any) 
    { 
      var shareperc: number;
      
      if ( event.argument == 'Actual' )
        {
          if ( this.barcharttree.length > 0 )
            {
              var selorgDollar: string;
              var selorgPerc: string;

              selorgDollar  =  "Me $:"
              selorgPerc    =  "Me %:"
              if ( this.organisername == 'Total')
                {
                  selorgDollar  =  "Tot $:"
                  selorgPerc    =  "Tot %:"
                }

              shareperc = +0
              if ( this.totalactualalloctaskbar > 0  &&  +event.value > 0 )
                {
                  shareperc = ( this.totalactualalloctaskbar /  this.totalactualspend  ) * 100;
                }

              return {

                html: `<table class="tg">` +

                          `<tr>` +
                            `<th>` + `<span style="color:black; font-size:10px; float:left">`   + "Bud $:"               + `</span>` + `</th>` +
                            `<th>` + `<span style="color:black; font-size:10px; float:right">`  + this.totalbudgetspendS  + `</span>` + `</th>` +
                          `</tr>` +

                          `<tr>` +
                            `<th>` + `<span style="color:black; font-size:10px; float:left">`   +  "Act $:"                + `</span>` + `</th>` +
                            `<th>` + `<span style="color:black; font-size:10px; float:right">`  +  this.totalactualspendS   + `</span>` + `</th>` +
                          `</tr>` +

                          `<tr>` +
                            `<th>` + `<span style="color:black; font-size:10px; float:left">`   +  selorgDollar                                                      + `</span>` + `</th>`     +
                            `<th>` + `<span style="color:black; font-size:10px; float:right">`  +  formatNumber(this.totalactualalloctaskbar, 'en-US', '1.2-2' )     + `</span>` + `</th>` +
                          `</tr>` +

                          `<tr>` +
                            `<th>` + `<span style="color:black; font-size:10px; float:left">`   +  selorgPerc            + `</span>` + `</th>` +
                            `<th>` + `<span style="color:black; font-size:10px; float:right">`  +  shareperc              + `</span>` + `</th>` +
                          `</tr>` +
                          
                    `</table>`

               // `<p>Budget:`      + `<span>` + this.totalbudgetspend + `</b>` + `</p>` +  `<br/>` +
               // `<p>Budget:`      + `<span style="color:black">` + this.totalbudgetspend + `</span>` + `</p>` +  `<br/>` +
                    
               
               
                //text: `<p>Budget:`      + `<span style="color:black;font-weight:bold">` + ' ' + this.totalbudgetspend + `</span>` + `</p>` +  `<br/>` +
                //            `<p>Actual:`      + this.totalactualspend + `</p>` +  `<br/>` +
                //            `<p>Allocated:`   + +event.value          + `</p>` +  `<br/>`
                //        
                        // text: `$aaaaaaaaaaaaaa<br/>${event.value}` + '#' + this.totalbudget
                        

                       // text:  this.totalbudgetspend + '#' + this.totalactualspend + '#' + +event.value + '#' + shareperc + '#' + `$aaaaaaaaaaaaaa<br/>${event.value}`
                     
                     
                 };
             }
          else
             {
                return '';
             }
        }
      else
        {
          return '';
        }
   
    }
  //*******************************************************
  priceColumn_customizeText (cellInfo) 
    {
      var cellvalue: string;

      cellvalue = cellInfo.value
      if ( cellvalue.length > 0  )
        {
          return cellvalue 
        }
      else
        {
          return ''; 
        }
    }
}
//*******************************************************
